export enum UserRole {
    user = "user",
    manager = "manager",
    admin = "admin"
}
